/*
 * @Descripttion:
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
import { PrivateService, Servlets } from '@/service';
import { Button } from '@alifd/next';
import React, { useState } from 'react';
import LzMsg from '../common/LzMsg';
import ConfirmDialog from '../Dialog/ConfirmDialog';

/**
 * @param deleteIds 要删除的任务id
 * @param deleteTaskApi 删除任务的接口名
 * @param refreshList 刷新任务列表的函数
 * @param boxStyle 删除按钮span标签的样式
 * @param disabledFlag 页面删除按钮是否禁用
 */

function DeleteTask(props) {
  const {deleteIds, deleteTaskApi, refreshList, boxStyle, disabledFlag} = props;
  const [deleteTaskFlag ,setDeleteTaskFlag] = useState(false);
  const [isClick,setIsClick] = useState(true);
  /**
   * 删除活动
   */
  const deleteTask = () => {
    if(isClick){
      setIsClick(false);
      if(deleteTaskApi === 'deleteCampaignTask') {
        Servlets(deleteTaskApi,{id: deleteIds})
        .then((res) => {
          if(res.data){
            LzMsg.success('删除成功');
            refreshList();
          }
          setDeleteTaskFlag(false);
        })
        .catch((e) => {
          console.log(e);
          setDeleteTaskFlag(false);
        });
      } else {
        Servlets(deleteTaskApi, deleteIds)
        .then((res) => {
          if(res.data){
            LzMsg.success('删除成功');
            refreshList();
          }
          setDeleteTaskFlag(false);
        })
        .catch((e) => {
          console.log(e);
          setDeleteTaskFlag(false);
        });
      }
    }
  };
  return (
    <span style={boxStyle}>
      <Button
        type='primary'
        text
        disabled={disabledFlag}
        onClick={() => {
          setDeleteTaskFlag(true);
        }}
      >
        删除
      </Button>
      {/* 二次确认删除弹窗 */}
      {deleteTaskFlag && (
        <ConfirmDialog
          type="WARN"
          title="提示"
          promptInfo={'确认删除该条数据？'}
          flag={deleteTaskFlag}
          confirmHandel={()=> {deleteTask()}}
          cancelHandel={() => {setDeleteTaskFlag(false)}}
        />
      )}
    </span>
  );
}

export default DeleteTask;
